import React, { useState } from "react";
import { Box, Typography, TextField } from "@mui/material";

export const Images = () => {
    const defaultImages = {
        coverPhoto: {
            value: "default_avatar",
            object: "/static/media/image_01.be3562b9.png",
            name: "default_avatar",
            type: "default",
            size: 0,
            updated: false,
        },
        morePhotos: [
            { link: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1741152722009.png", size: 96769, name: "image_02 - Copy.png", type: "image/png" },
            { link: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1741152722013.png", size: 99643, name: "image_03 - Copy.png", type: "image/png" },
            // { link: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1741152722018.png", size: 1024235, name: "Rectangle 8.png", type: "image/png" },
            // { link: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1741152722022.png", size: 214691, name: "image_04.png", type: "image/png" },
            // { link: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1741152722026.png", size: 1114161, name: "Rectangle 5.png", type: "image/png" },
            // { link: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1741152722030.png", size: 194467, name: "default06.png", type: "image/png" },
        ],
    };

    const [images] = useState(defaultImages);
    return (
        <Box mt={2}>
            <Typography variant="body1" color="text.primary" sx={{ fontSize: "1rem", fontWeight: "700", marginBottom: "0.5rem", }}>Property Cover Photo<Typography component="span" color="error"> * </Typography></Typography>
            <Box display="flex" alignItems="center" justifyContent="center"
                sx={{
                    textAlign: "center",
                    marginTop: 1,
                    cursor: "pointer",
                    position: "relative",
                    width: "100%",
                    height: "12.5rem",
                    border: `2px dashed grey`,  
                    borderRadius: "8px",
                }}
            > 
                <Typography variant="body1">
                    Upload photos as jpg or png.
                </Typography>
            </Box>
            <Typography variant="body1" color="text.primary" sx={{ fontSize: "1rem", fontWeight: "700", marginBottom: "0.5rem", marginTop: "1rem"}}>More Photos<Typography component="span" color="error"> * </Typography></Typography>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
                    gap: 2,
                }}
            >
                {images.morePhotos.map((photo, index) => (
                    <Box key={index}
                        sx={{
                            height: "9.375rem", 
                            borderRadius: "8px",
                            border: `2px dashed grey`,  
                            position: "relative",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}>
                        <Typography variant="body1">
                            Add Photo
                        </Typography>
                    </Box>
                ))}
            </Box>
            <Box mt="0.5rem">
                <Typography m="1rem 0 0.5rem"> Youtube video link of your property </Typography>
                <TextField label="Input link here . . ." variant="outlined" fullWidth size="small" disabled sx={{ backgroundColor: "#ffffff" }}/>
            </Box>
        </Box>
    );
};